export default "__VITE_ASSET__c87c13e2__"